import {ExpressionPath} from '@packages/systems/wfdl';

export const CHILDREN_PATH: ExpressionPath = [{in: 'Record', at: 'children'}];
export const ELEMENT_CHILDREN_PATH: ExpressionPath = [
  {in: 'Element'},
  {in: 'Record', at: 'children'},
];
export const TABS_PATH: ExpressionPath = [{in: 'Record', at: 'tabs'}];
export const FADE_IN_PATH: ExpressionPath = [
  ...TABS_PATH,
  {in: 'Record', at: 'fadeIn'},
];
export const FADE_OUT_PATH: ExpressionPath = [
  ...TABS_PATH,
  {in: 'Record', at: 'fadeOut'},
];
export const EASING_PATH: ExpressionPath = [
  ...TABS_PATH,
  {in: 'Record', at: 'easing'},
];
// Previously, `tabs.current` stored the active tab and was used for both
// display and persistence. After session-local tab switching was introduced
// (COL-6826), the actively-viewed tab moved to a temp path
// (`temp.tabs.current`) that doesn't sync across sessions. This persisted
// path now represents which tab is shown on the published site (the
// "default" tab). The key stays as 'current' for backwards compatibility
// with existing site data.
export const DEFAULT_TAB_PATH: ExpressionPath = [
  ...TABS_PATH,
  {in: 'Record', at: 'current'},
];
export const NONE_TAB_ID = '__none__';
export const DATA_W_TAB_PATH: ExpressionPath = [
  {in: 'Record', at: 'attr'},
  {in: 'Record', at: 'data-w-tab'},
];
